import Link from 'next/link';
import React from 'react';

import { Button, Label, TseCheck } from '@shared/ui';

import { fundAwardLanguage } from '../../model';

export const CheckTseMarket = () => {
  return (
    <div className='flex flex-col gap-4 items-center justify-center max-w-[440px]'>
      <TseCheck />
      <Label className='h5-bold'>{fundAwardLanguage.checkTseMarket}</Label>
      <p className='body-12-regular'>{fundAwardLanguage.checkTseMarketDescription}</p>
      <Link
        target='_blank'
        href='http://regapi.agah.com/login'
        className='w-full h-auto items-start flex justify-center mt-4'
      >
        <Button className='h-[60px] w-full gap-x-1' type='submit'>
          {fundAwardLanguage.checkTseMarketButton}
        </Button>
      </Link>
    </div>
  );
};
